export interface IFollowUpItem {
	followupId: number;
	followupName: string;
	followupDisplayName: string;
	followupType: string;
	caseCount: number;
	pinStatus: boolean;

	filterId: number | string;
	isFilter: boolean;
	filterName: string;
	caseType: string;
	reasonIds: string;
	extendedFilters: string;
	status: string;
	claimOwnership: string;
	caseHandlers: string;
    createdUser: string;
}

export enum FollowUpPinStatus {
	PIN = 'Pin',
	UNPIN = 'UnPin',
	ALL = 'All',
}

export type Followup = {
	followupId: number;
	followupName: string;
	followupDisplayName: string;
	followupType: string;
	caseCount: number;
	pinStatus: boolean;
	description: string;
	entityType: string;
	customQuery: string;
	createdUser: string;
	createdDate: string;
};